import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../authentication/authentication.service";
var ChangePasswordService = /** @class */ (function () {
    function ChangePasswordService(http, authenticationService) {
        this.http = http;
        this.authenticationService = authenticationService;
    }
    ChangePasswordService.prototype.changeUserPassword = function (_a) {
        var oldPassword = _a.oldPassword, newPassword = _a.newPassword;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = environment.MORANNON_URL + "/auth/change-password";
                        return [4 /*yield*/, this.http.post(url, {
                                accessToken: this.authenticationService.accessToken,
                                oldPassword: oldPassword,
                                newPassword: newPassword
                            })
                                .toPromise()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangePasswordService.prototype.generatePassword = function () {
        var password = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$';
        for (var i = 0; i < 8; i++) {
            password += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        if (this.isValidPassword(password)) {
            return password;
        }
        else {
            return this.generatePassword();
        }
    };
    ChangePasswordService.prototype.isValidPassword = function (password) {
        var checks = [
            /[A-Z]/.test(password),
            /[a-z]/.test(password),
            /\d/.test(password),
            /[@#$]/.test(password),
        ];
        return checks.reduce(function (sum, current) { return sum + Number(current); }, 0) === 4;
    };
    ChangePasswordService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChangePasswordService_Factory() { return new ChangePasswordService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService)); }, token: ChangePasswordService, providedIn: "root" });
    return ChangePasswordService;
}());
export { ChangePasswordService };
